export const MetricToggle = ({ value, onChange, options, prefix = "metric-toggle" }) => (
  <div className="inline-flex rounded-lg border border-slate-800 bg-[#0B0F19] p-1">
    {options.map(([k, label]) => (
      <button
        key={k}
        data-testid={`${prefix}-${k}`}
        onClick={() => onChange(k)}
        className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors duration-150 ${value === k ? "bg-slate-700 text-white" : "text-slate-400 hover:text-slate-200"}`}
      >
        {label}
      </button>
    ))}
  </div>
);
